import React from 'react';
import { useFilters } from './useFilters';
import { CalendarIcon } from 'components/common/icons';
import { Col, DatePicker, FilterDrawer, Form, FormInstance, Row, Select } from 'components';
import { AdminsSelect } from 'components/common/adminsSelect';
import { AllEntityTypes, PriorityTypes, StatusTypes } from 'models/Task';
import styles from 'pages/admin/clients/styles.module.scss';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  entityType?: string;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, entityType, closeDrawer, applyFilters, resetFilters } = props;
  const { clearFilters } = useFilters({ form, resetFilters });
  const { hasAccess } = useAccessControl();

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }} // Add space for drawer actions
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={applyFilters}
        initialValues={{
          assignedTo: null,
          entityType: null,
          roleId: null,
          createdBy: null,
          status: [],
          priorityLevel: [],
          createdDate: [null, null],
          lastUpdatedDate: [null, null],
          dueDate: [null, null],
        }}
      >
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="assignedTo" label={'Assigned To'}>
              <AdminsSelect />
            </Form.Item>
          </Col>
          {!entityType && (
            <Col span={24}>
              <Form.Item name="entityType" label={'Entity Type'}>
                <Select options={Object.values(AllEntityTypes).filter((i) => hasAccess(i.permission))} />
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item name="createdBy" label={'Created By'}>
              <AdminsSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdDate" label={'Created Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastUpdatedDate" label={'Last Updated Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="dueDate" label={'Due Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="priorityLevel" label={'Priority'}>
              <Select mode={'multiple'} options={PriorityTypes} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="status" label={'Status'}>
              <Select mode={'multiple'} options={StatusTypes} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
